<template>
    <div>
        <div id="outcome-wrapper" v-if="ctrl_game.showOutcome">
            <video v-if="!ctrl_game.showLooping" autoplay @ended="ctrl_game.setLooping()" :src="ctrl_game.outcomeSrc" />
            <video v-if="ctrl_game.showLooping" autoplay loop :src="ctrl_game.loopingSrc" />
            <div id="overlay" v-if="ctrl_game.showClose">
                <div class="button-container">
                    <a @click.prevent="ctrl_game.resetGame()" href="#">
                        <p><span class="bg"></span><span class="base"></span><span class="text">CLOSE</span>
                        </p>
                    </a>
                </div>
                <!-- <a @click.prevent="ctrl_game.resetGame()" href="something" class="button2">CLOSE</a> -->
            </div>
        </div>
        <slot v-else></slot>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                ctrl_game: this.ctrl_game(),
            }
        },
        mounted() {
            console.log(this.ctrl_game);
        }
    }
</script>